/**
 * Safe path(+query) for MCP browser-consent SPA post-login redirects.
 * Must stay identical across **`apps/web`** OAuth initiation/callback and the SPA **`/signin`** allowlist.
 */
const MCP_AUTHORIZE_RELATIVE_RE = /^\/mcp\/authorize(?:\?[a-zA-Z0-9\-._~!$&'()*+,;=:?/@%]*)?$/;
/**
 * Validates a same-origin-relative path carrying the pending authorization **`req`** id query.
 *
 * Accepts **`unknown`** so callers using **`req.query['return_to']`** can thread through without coercion.
 */
export function parseSafeHostedMcpAuthorizeReturnPath(raw) {
    if (typeof raw !== 'string' || raw.length === 0 || raw.length > 2048) {
        return null;
    }
    if (raw.includes('://') || raw.startsWith('//')) {
        return null;
    }
    if (!raw.startsWith('/')) {
        return null;
    }
    return MCP_AUTHORIZE_RELATIVE_RE.test(raw) ? raw : null;
}
//# sourceMappingURL=mcp-authorize-return-to.js.map